import React from "react";
import { Space, Result, Button, Layout, message } from "antd";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { unsubscribeUser } from "../../redux/actions/publicAction";

export default function Unsubscribe() {
  const dispatch = useDispatch();
  const { emailAddress, organizationName, campaignId } = useParams();

  const handleUnsubscribe = () => {
    dispatch(
      unsubscribeUser({
        emailAddress,
        organizationName,
        campaignId,
      }),
    )
      .then((response) => {
        message.success(response.message);
      })
      .catch((e) => console.log(e));
  };

  return (
    <Layout>
      <Space
        direction="vertical"
        align="center"
        style={{ display: "flex", height: "100vh", justifyContent: "center" }}
      >
        <Result
          status="error"
          title="Unsubscribe from Email List"
          subTitle="We're sorry to see you go! Please confirm your decision to unsubscribe from our email list."
          extra={[
            <Button type="primary" key="unsubscribe" onClick={() => handleUnsubscribe()}>
              Unsubscribe
            </Button>,
          ]}
        />
      </Space>
    </Layout>
  );
}
